export const NUMBER_SHARE_REQUEST = 'NUMBER_SHARE_REQUEST';
export const NUMBER_SHARE_SUCCESS = 'NUMBER_SHARE_SUCCESS';
export const NUMBER_SHARE_ERROR = 'NUMBER_SHARE_ERROR';

export const SERVICE_NUMBER_SHARE_REQUEST = 'SERVICE_NUMBER_SHARE_REQUEST';
export const SERVICE_NUMBER_SHARE_SUCCESS = 'SERVICE_NUMBER_SHARE_SUCCESS';
export const SERVICE_NUMBER_SHARE_ERROR = 'SERVICE_NUMBER_SHARE_ERROR';

export const NUMBER_SHARE_ELIGIBILITY_REQUEST = 'NUMBER_SHARE_ELIGIBILITY_REQUEST';
export const NUMBER_SHARE_ELIGIBILITY_SUCCESS = 'NUMBER_SHARE_ELIGIBILITY_SUCCESS';
export const NUMBER_SHARE_ELIGIBILITY_ERROR = 'NUMBER_SHARE_ELIGIBILITY_ERROR';
